import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import {
  getProjectContent,
  getLoadingProjectDatasets,
  getLoadingProjectSubprojects,
  getProjectPagination,
  getProjectRowsPerPage,
  getProjectContentTotalCount,
  getProjectContentSortBy,
  getProjectContentSortOrder,
  getProjectContentNamePrefix
} from '../state'

import ProjectContentTable from '../components/ProjectContentTable'

const mapStateToProps = createSelector(
  [
    getProjectContent,
    getLoadingProjectDatasets,
    getLoadingProjectSubprojects,
    getProjectPagination,
    getProjectRowsPerPage,
    getProjectContentTotalCount,
    getProjectContentSortBy,
    getProjectContentSortOrder,
    getProjectContentNamePrefix
  ],
  (
    projectContent,
    loadingDatasets,
    loadingSubprojects,
    page,
    rowsPerPage,
    totalCount,
    sortBy,
    sortOrder,
    namePrefix
  ) => ({
    projectContent,
    loading: loadingDatasets || loadingSubprojects,
    page,
    rowsPerPage,
    totalCount,
    sortBy,
    sortOrder,
    namePrefix
  })
)

export default connect(mapStateToProps)(ProjectContentTable)
